export function extractUTM(urlStr) {
    const url = new URL(urlStr);
    const rec = {};
    for (const [key, val] of url.searchParams) {
        switch (key) {
            case "utm_source":
            case "utm_medium":
            case "utm_campaign":
            case "utm_term":
            case "utm_content":
                rec[`UTM@@${key}`] = val;
                break;
        }
    }
    return Object.keys(rec).length > 0 ? rec : undefined;
}
